import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import logo from '../../styles/quality-shield-logo.png'; // Adjust the path to your logo file
import axiosInstance from './api';
import { useParams } from 'react-router-dom';

const PasswordReset = ({ uidb64, token ,onLogin }) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null); // State for success alert

    const history = useHistory();

  
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }
    const handleConfirmPasswordChange = (e) => {
        if (e.target.value !== password) {
            setError("Passwords do not match");
        } else {
            setError(null);
        }
        setConfirmPassword(e.target.value);
    }

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setError(null);

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            const response = await fetch(`/api/reset-password/${uidb64}/${token}/`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ new_password: password }),
              });
            if (response.status === 200) {
                setSuccessMessage('Password reset successfully! You can now log in.');

                setTimeout(() => {
                    onLogin(); // Notify the app that the user has logged in
                    history.push('/'); // Redirect to the dashboard or home page
                }, 3000); // 3-second delay
            }
        } catch (err) {
            setError(err.response?.data?.detail || err.message || 'An error occurred while resetting the password');
        }
    }


  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: 'auto',
        mt: 8,
        p: 4,
        borderRadius: 2,
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#ffffff',
        textAlign: 'center',
      }}
    >
      {/* Logo */}
      <Box sx={{ mb: 3 }}>
        <img src={logo} alt="QualityShield Logo" style={{ width: '150px' }} />
      </Box>

      {/* Title */}
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
        Login
      </Typography>
      {/* Success Message */}
      {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}
      {/* Error Message */}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      {/* Login Form */}
      
     
        <Typography variant="body1" sx={{ mb: 2 }}>
        Please enter your new password
        </Typography>
        <form onSubmit={handlePasswordReset}>
        <TextField
            label="New password"
            type="password"
            fullWidth
            margin="normal"
            value={password} // Reusing email state for 2FA code input
            onChange={handlePasswordChange}
        />
        <TextField
            label="Confirm new password"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword} // Reusing email state for 2FA code input
            onChange={handleConfirmPasswordChange}
        />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Change Password
        </Button>
        </form>
    </Box>
  );
};

export default PasswordReset;
